import React, {Component} from 'react';
import {withSession} from "../Session/context";
import {withFirebase} from "../Firebase";
import Header from "../Header";
import Input from "../Input";
import languages from "../../utils/languages";
import PageSuccess from "../Page_Success";

class PageTranslate extends Component {

    _placeHolderMaps = {
        "%1$s": "[W1]",
        "%1$d": "[N1]",
        "%2$s": "[W2]",
        "%2$d": "[N2]",
        "%3$s": "[W3]",
        "%4$s": "[W4]",
        "%3$d": "[N3]",
        "%1$f": "[D1]",
        "%2$f": "[D2]",
        "%3$f": "[D3]"
    };

    constructor(props) {
        super(props);
        this.state = {
            displayLanguage: languages[props.match.params.language],
            projectId: props.match.params.project,
            language: props.match.params.language,
            inputs: {},
            submitted: false,
            existing: []
        };
    }
    componentDidMount() {
        this.props.firebase.getProject(this.state.projectId).then(project => {
            this.setState({ project: project })
        });

        this.props.firebase.getExistingTranslations(this.state.projectId,this.state.language).then(existing => {
            this.setState({ existing: existing || [] })
        });
    }

    handleCheckClick = () => {
        this.setState({ checked: !this.state.checked });
    };

    handleInputChange = (key,event) => {
        const input = event.target.value;
        this.setState((prev,props) => ({
            inputs: {
                ...prev.inputs,
                [key]: input
            }
        }));
    };

    addUserFriendlyPlaceholders(phrase) {
        if(!phrase) return null;

        // the type of is for a weird issue (though logical)
        // if we don't have an existing value and we get the key for "filter"
        // then it returns the prototype impl and crashes
        if(typeof phrase != 'string') return null;

        let output = phrase;
        const keys = Object.entries(this._placeHolderMaps);
        for(const [key,value] of keys) {
            output = output.replace(key,value);
        }

        output = output.replace(/\\n/g," ");

        return output;
    }

    removeUserFriendlyPlaceholders(phrase) {
        let output = phrase;
        const keys = Object.entries(this._placeHolderMaps);
        for(const [key,value] of keys) {
            output = output.replace(value,key);
        }
        return output;
    }

    verifyValidPlaceholders(original,input) {
        const regex = /%\d\$[a-z]/g;
        const originalMatches = original.match(regex);
        const inputMatches = input.match(regex);
        if((originalMatches == null) !== (inputMatches == null)) return false; // either both exist or both don't exist
        if(originalMatches == null) return true; // now just a check to see if it's null (which means both are)
        if(originalMatches.length !== inputMatches.length) return false;
        return originalMatches.every(item => inputMatches.includes(item));
    }

    getWarnings(original) {
        const regex = /%\d\$[a-z]/g;
        const originalMatches = original.match(regex);
        if(originalMatches == null) return;
        const warnings = [];
        for(const match of originalMatches) {
            const placeholder = this.addUserFriendlyPlaceholders(match);
            warnings.push(`${placeholder} will be replace by a word or number. You MUST include it in your translation.`);
        }
        return warnings;
    }

    handleSubmit = (event) => {
        event.preventDefault();

        const submittedTranslations = {};
        const inputs = this.state.inputs;
        const existing = this.state.existing;

        Object.keys(this.state.project.strings).forEach((key) => {
           if(inputs[key]) {
               const convertedPhrase = this.removeUserFriendlyPlaceholders(inputs[key]);
               if(convertedPhrase !== existing[key] && convertedPhrase.length>1 && this.verifyValidPlaceholders(this.state.project.strings[key],convertedPhrase)) {
                   submittedTranslations[key] = convertedPhrase;
               }
           }
        });

        if(Object.entries(submittedTranslations).length > 0) {
            this.props.firebase.addSubmission(this.state.projectId,this.state.language,submittedTranslations);
        }

        this.setState({
            submitted: true
        });
    };

    render() {

        if(!this.state || !this.state.project || !this.state.existing) return null;
        if(this.state.submitted) return (<PageSuccess/>);

        const projectStringKeys = Object.keys(this.state.project.strings);
        const existingStringKeys = Object.keys(this.state.existing);
        const showExisting = this.state.checked;

        let showKeys = [];

        if(showExisting) {
            showKeys = projectStringKeys
        } else {
            showKeys = projectStringKeys.filter(key => !existingStringKeys.includes(key))
        }

        const listItems = showKeys.map((key) => {
            return (
                <React.Fragment key={key}>
                    <Input
                        onChange={(event) => this.handleInputChange(key,event)}
                        placeholder={`Translate into ${this.state.displayLanguage}...`}
                        original={this.addUserFriendlyPlaceholders(this.state.project.strings[key])}
                        warnings={this.getWarnings(this.state.project.strings[key])}
                        value={this.state.inputs[key] || this.addUserFriendlyPlaceholders(this.state.existing[key]) || ""} />
                    <hr />
                </React.Fragment>
            )
        });

        return (
            <form onSubmit={this.handleSubmit}>
                <Header title={`Submit translations for ${this.state.displayLanguage}`} subtitle={this.state.project.title} />
                <p>
                    You do not need to enter all translations before submitting, partial submissions are accepted.
                </p>
                <label>
                    <input type="checkbox" checked={this.state.checked} onChange={this.handleCheckClick} />Show already translated phrases
                </label>
                {listItems}
                <input type="submit" value="Submit translations" />
            </form>
        );
    }
}

export default withSession(withFirebase(PageTranslate));